import React, { useEffect, useCallback, useState } from 'react';
import base64 from 'react-native-base64';

import { FormattedMessage, injectIntl } from 'react-intl';

import Button from '@material-ui/core/Button';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import { makeStyles } from '@material-ui/core/styles';
import NearMeIcon from '@material-ui/icons/NearMe';
import LockIcon from '@material-ui/icons/Lock';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { useHistory } from 'react-router-dom';

import { useDispatch } from 'react-redux';
import { setFromLogin, showLoading, hideLoading } from 'app/store/slices/settings';

import { URLS } from 'app/config/urls';
import { Formik, Form, Field } from 'formik';
import { Box, Grid, TextField } from '@material-ui/core';
import { clearServices } from 'app/store/slices/services';
import { logOut, logIn } from 'app/store/slices/user';
import * as Yup from 'yup';

import styles from './styles';
import notification from 'app/config/notification';
import authEndpoints from 'app/api/services/authEndpoints';
import { errorHandler } from 'app/utils/errorHandler';
const useStyles = makeStyles(styles);

const validationSchema = Yup.object().shape({
  password: Yup.string().required('Senha é obrigatória'),
  passwordConfirm: Yup.string().required('Confirmação de senha é obrigatória'),
});

function ResetPassword(props) {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();

  const { intl } = props;

  const [passwordData, setPasswordData] = useState('');

  const logo = process.env.PUBLIC_URL + '/img/logo-login.png';

  const goToLogin = useCallback(async () => {
    dispatch(showLoading());
    dispatch(setFromLogin(false));
    dispatch(clearServices());
    await logOut(dispatch);
    history.push(URLS.LOGIN);
    dispatch(hideLoading());
  }, [dispatch, history]);

  useEffect(() => {
    dispatch(setFromLogin(false));
    if (!props.match.params.user || !props.match.params.password) {
      goToLogin();
    }
    const passData = {
      user: base64.decode(props.match.params.user),
      password: base64.decode(props.match.params.password),
    };
    setPasswordData(passData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, goToLogin]);

  const sendChangePassword = async values => {
    if (!values.password || !values.passwordConfirm) {
      notification(
        intl.formatMessage({
          id: 'MESSAGES.LOGIN.MISSING_MANDATORY_INFO_CHANGE_PASS',
        }),
        {
          toastId: 'MISSING_MANDATORY_INFO_CHANGE_PASS',
          type: 'error',
        }
      );
      return false;
    }
    if (values.password !== values.passwordConfirm) {
      notification(
        intl.formatMessage({
          id: 'MESSAGES.LOGIN.PASSWORD_DOESNT_MATCH',
        }),
        {
          toastId: 'MISSING_MANDATORY_INFO_CHANGE_PASS',
          type: 'error',
        }
      );
      return false;
    }

    dispatch(showLoading());
    try {
      const responseLogin = await logIn({
        username: passwordData.user,
        password: passwordData.password,
      }, dispatch);

      if (!responseLogin) {
          notification(
              intl.formatMessage({
                  id: 'MESSAGES.LOGIN.PASSWORD_CHANGED_ERROR',
              }),
              { toastId: 'PASSWORD_CHANGED_ERROR', type: 'error' }
          );
          dispatch(hideLoading());
          return;
      }
      const response = await authEndpoints.changePassword(passwordData.password, values.password);
      if (response.status === 200) {
        notification(
          intl.formatMessage({
            id: 'MESSAGES.LOGIN.PASSWORD_CHANGED',
          }),
          { toastId: 'PASSWORD_CHANGED', type: 'success' }
        );
      }
    history.push(URLS.START);

    } catch (error) {
      await logOut(dispatch);
      errorHandler(error.response?.status, error.response?.data?.message);
    }
    dispatch(hideLoading());
  };

  return (
    <div className={classes.container}>
      <Card className={classes.boxLogin}>
        <CardContent className={classes.content}>
          <Button className={classes.backButton} onClick={() => goToLogin()}>
            <KeyboardArrowLeft />
            <FormattedMessage id="LABELS.LOGIN.LOGIN" />
          </Button>
          <img className={classes.logo} src={logo} alt="logo" />

          <Formik
            initialValues={{ password: '', passwordConfirm: '' }}
            validateOnBlur={false}
            validationSchema={validationSchema}
            validateOnChange={false}
            onSubmit={values => {
              sendChangePassword(values);
            }}
          >
            {({ errors }) => {
              return (
                <Form>
                  <Box maxWidth={400} padding={4}>
                    <Grid container spacing={3}>
                      <Grid
                        item
                        xs={12}
                        className={[classes.boxRecoveryInfo, classes.textBlue].join(' ')}
                      >
                        <h2 className={classes.subtitle}>
                          <FormattedMessage id="LABELS.LOGIN.PASSWORD_CHANGING" />
                        </h2>
                        <p className={classes.observation}>
                          <FormattedMessage id="LABELS.LOGIN.PASSWORD_RESET_OBS" />
                        </p>
                      </Grid>
                      <Grid item xs={12} className={classes.boxTextField}>
                        <LockIcon className={classes.icone} color="disabled" />
                        <Field
                          name="password"
                          label="Nova Senha"
                          type="password"
                          variant="filled"
                          fullWidth
                          error={!!errors.password}
                          as={TextField}
                        />
                      </Grid>
                      <Grid item xs={12} className={classes.boxTextField}>
                        <LockIcon className={classes.icone} color="disabled" />
                        <Field
                          name="passwordConfirm"
                          label="Confirmar Senha"
                          type="password"
                          variant="filled"
                          fullWidth
                          error={!!errors.passwordConfirm}
                          as={TextField}
                        />
                      </Grid>
                      <Grid item xs={12} className={classes.item}>
                        <Button
                          variant="contained"
                          color="primary"
                          type="submit"
                          className={classes.loginButton}
                        >
                          <FormattedMessage id="LABELS.COMMONS.SEND" />
                          <NearMeIcon className={classes.iconSend} />
                        </Button>
                      </Grid>
                    </Grid>
                  </Box>
                </Form>
              );
            }}
          </Formik>
        </CardContent>
      </Card>
    </div>
  );
}

export default injectIntl(ResetPassword);
